export default "__VITE_ASSET__Djp__xc2__"